import { Component, HostListener, OnDestroy, OnInit, SecurityContext } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { GetStartedModalComponent } from 'src/app/shared/components/get-started-modal/get-started-modal.component';
import { filter, takeUntil } from 'rxjs/operators';
import { DeviceInventoryService } from 'src/app/core/services/device-inventory.service';
import { ISelectedContract, LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { ISitefinityContentSettings, SitefinityContentService } from 'src/app/core/services/settings/sitefinity-content.service';
import { IDashboardCard } from 'src/app/model/dashboard/dashboard-card';
import { INoticeBanner, getNoticeText } from 'src/app/model/notice-banner/notice-banner';
import { ITechServicesComponent, IUpgradeBanner } from 'src/app/model/sitefinity/IDashboard';
import { combineLatest, Subject, tap, concatMap } from 'rxjs';
import { IPromoSlot } from 'src/app/model/promos/IPromoSlot';
import { OktaUserProfile, UserClaims } from 'src/app/model/okta/userClaims';
import { CHAT, CHATGROUP, TECHGROUP, TECHSERVICES } from 'src/app/core/constants/feature-key.constants';
import { myTechServicesRouteWithSlash } from '../../../route-constants';
import { MobileDeviceService } from 'src/app/core/services/mobile-device.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { ActivatedRoute, Router } from '@angular/router';
import { InventoryInfoDto } from 'src/app/core/services/device-inventory/inventory-info.dto';
import { DeviceDto } from 'src/app/core/services/device-inventory/device.dto';
import { ClaimsNoDevicesModalWindowComponent } from 'src/app/shared/components/claims-no-devices-modal-window/claims-no-devices-modal-window.component';
import { SelectedDeviceService } from 'src/app/shared/device/selected-device.service';
import { GSSPAuthenticationService } from 'src/app/core/services/gssp-authentication.service';
import { DomSanitizer } from '@angular/platform-browser';
import { DeviceCardDiagnosticTestStatus } from 'src/app/shared/device/device-card/device-card.component';
import { ADPResourceService, SitefinityImage } from 'digital-core';
import { IAppPromoSlot } from 'src/app/model/promos/IAppPromo';
import { AccountService } from 'src/app/core/services/account.service';
import { UpdateUserInfoDevicesCountDto } from 'src/app/model/account/update-user-info-devices-count.dto';
import { UserInfoReportingService } from 'src/app/core/services/user-info-refporting.service';
import { PghUserDeviceBase } from 'src/app/shared/device/pgh-user-device';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogData } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog-data';
import { GoogleAnalyticsService } from 'src/app/core/services/google-tag-manager.service';
import { GTMLoginEvents } from 'src/app/model/google-tag-manager/api-status';
import { StorageService } from 'src/app/core/services/storage.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { IFaqListItemKeys } from 'src/app/model/sitefinity/IFaq';
import { ChatHandler } from '../../../core/handler/chat-handler';
import { AsappChatService } from '../../../core/services/asapp-chat.service';
import { addDays, differenceInCalendarDays, format, startOfDay } from 'date-fns';
import { IContract } from 'src/app/model/contract/IContract';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, OnDestroy {
  homeDevicesCard: IDashboardCard;
  isCancelled: boolean = null;
  isSuspended: boolean = null;
  isExpired: boolean = null;
  cancelledOrExpiredHasFullAccess: boolean = false;
  isFirstTimeUser = false;
  isPTPO: boolean = null;
  isPrimary: boolean = null;
  hasActiveAccount: boolean = null;
  noticeBanners: INoticeBanner[]= [];
  promoDashboardSlot: IPromoSlot = null;
  promoDashboardAppTypeSlot: IAppPromoSlot = null;
  techServicesDashboardCard: IDashboardCard;
  upgradeBanner: IUpgradeBanner;
  isTechServicesEnabled: boolean = false;
  isTechServicesChatEnabled: boolean = false;
  techServicesofferList: string[];
  supportCenterOfferedServicesList: string[];
  supportCenterComponentRoute: string;
  isPhonePlanSupported: boolean = false;
  showDisclaimer: boolean = true;
  bannersVisibility: boolean[] = [];
  accountManagementUrl: string;
  accountManagementLabel: string;
  // familyManagementLink: INavigationItem;
  disableCntrl: boolean = false;
  smartDevicesCount: number = 0;
  isMobilePlan: boolean = false;
  techServicesComponent: ITechServicesComponent;
  public benefitsOfferedList: string[] = [];
  private destroy$ = new Subject<boolean>();
  address: string;
  address1: string;
  selectedPlan: string;
  welcomeBackMessage: string;
  welcome: string;
  programCode: string;
  techServicesRoute: string = myTechServicesRouteWithSlash;
  mobileDeviceSummary: { phonesRegistered: number; phonesNotRegistered: number; mobilePhones: number };
  isNative: any;
  isDashboardVisible: boolean = false;
  skippedPhoneTest: boolean = false;
  private deviceInventoryInfo?: InventoryInfoDto;
  isNewUserFlow: string = 'false';
  private phonedeviceInventoryInfo?: InventoryInfoDto;
  private phoneInventoryInfo?: InventoryInfoDto;
  phoneDevices: DeviceDto[];
  isPhonesStatusPending: boolean = false;
  isPhonesStatusFailed: boolean = false;
  isSupportOffered: boolean = true;
  isSPOEEnabled: boolean = false;
  public homePlanFAQListItems: IFaqListItemKeys[] = [];
  public mobilePlanFAQListItems: IFaqListItemKeys[] = [];
  public coverageMobilePlanList: string[] = [];
  public coverageHomePlanList: string[] = [];
  public faqImageKey: string = '';
  public claimsBackgroundImageURL: string = '';
  public devicesBackgroundImageURL: string = '';
  public chatSupportBackgroundImageURL: string = '';
  public techServicesSupportBackgroundImageURL: string = '';
  public hasP360MobilePolicy = false;
  public hasP360HomeTechPolicy = false;
  public hasMultiPolicies = false;
  public isMobileSize: boolean = false;

  smartDeviceImage: SitefinityImage;
  deviceRoute: string = '';
  userEmail: string;

  constructor(
    private loggedInUserSettings: LoggedInUserSettings,
    private sitefinityContentService: SitefinityContentService, // This can be removed when we sunset the old portals. When we sunset the old portal, we can delete the UpgradeCallout component which is the only thing left for using this service.
    private matDialog: MatDialog,
    private deviceInventoryService: DeviceInventoryService,
    private mobileDeviceService: MobileDeviceService,
    private util: UtilityService,
    public route: ActivatedRoute,
    public router: Router,
    private sanitizer: DomSanitizer,
    private gsspAuthService: GSSPAuthenticationService,
    private selectedDeviceService: SelectedDeviceService,
    private resourceService: ADPResourceService,
    private userInfoReportingService: UserInfoReportingService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private accountService: AccountService,
    private storageService: StorageService,
    private breakpointObserver: BreakpointObserver,
    private asappChatService: AsappChatService
  ) {
    this.breakpointObserver.observe([Breakpoints.Small, Breakpoints.XSmall]).subscribe((result) => {
      this.isMobileSize = result.matches;
    });

    this.route.queryParams.subscribe((params) => {
      this.isNative = (params.isNative && params.isNative.toLowerCase().trim() === 'true') || this.util.isNativeApp;
      this.isNewUserFlow = params['isNewUserFlow'];
    });
    if (this.isNative) {
      this.isDashboardVisible = false;
      const lastPage = sessionStorage.getItem('last-page-access');

      if (lastPage !== null && lastPage.toLowerCase().indexOf('claims') > -1) {
        this.router.navigate(['claims']);
      }else{
        this.router.navigate(['account']);
      }
    }
    const redirectTo = sessionStorage.getItem('redirect-to');
    if (redirectTo && redirectTo == 'gssp-claims') {
      sessionStorage.removeItem('redirect-to');
      this.redirectToGsspDashboard();
    }
  }

  @HostListener('window:resize', ['$event'])
    onResize(event) {
      this.isMobileSize = window.innerWidth < 992;
      //this.claimsBackgroundImageURL = this.isMobileSize? this.resourceService.getPortalImage("Global_SPOE_Dashboard_Claims_Image_Mobile").ImageURL : this.resourceService.getPortalImage("Global_SPOE_Dashboard_Claims_Image_Desktop").ImageURL;
      //this.devicesBackgroundImageURL = this.isMobileSize? this.resourceService.getPortalImage("Global_SPOE_Dashboard_Devices_Image_Mobile").ImageURL : this.resourceService.getPortalImage("Global_SPOE_Dashboard_Devices_Image_Desktop").ImageURL
      this.chatSupportBackgroundImageURL = this.isMobileSize? this.resourceService.getPortalImage("Global_SPOE_Dashboard_Chat_Image_Mobile").ImageURL : this.resourceService.getPortalImage("Global_SPOE_Dashboard_Chat_Image_Desktop").ImageURL;;
      this.techServicesSupportBackgroundImageURL = this.isMobileSize? this.resourceService.getPortalImage("Global_SPOE_Dashboard_TechServices_Image_Mobile").ImageURL : this.resourceService.getPortalImage("Global_SPOE_Dashboard_TechServices_Image_Desktop").ImageURL;

      if((this.hasP360MobilePolicy && !this.hasP360HomeTechPolicy) || (this.hasP360MobilePolicy && this.hasP360HomeTechPolicy)){
          this.claimsBackgroundImageURL = this.isMobileSize? this.resourceService.getPortalImage("Global_SPOE_Dashboard_Claims_Image_Mobile").ImageURL : this.resourceService.getPortalImage("Global_SPOE_Dashboard_Claims_Image_Desktop").ImageURL;
          this.devicesBackgroundImageURL = this.isMobileSize? this.resourceService.getPortalImage("Global_SPOE_Dashboard_Devices_Image_Mobile").ImageURL : this.resourceService.getPortalImage("Global_SPOE_Dashboard_Devices_Image_Desktop").ImageURL;
        }
        else{
          this.claimsBackgroundImageURL = this.isMobileSize? this.resourceService.getPortalImage("Global_SPOE_Dashboard_Claims_HomeTech_Image_Mobile").ImageURL : this.resourceService.getPortalImage("Global_SPOE_Dashboard_Claims_HomeTech_Image_Desktop").ImageURL;
          this.devicesBackgroundImageURL = this.isMobileSize? this.resourceService.getPortalImage("Global_SPOE_Dashboard_Devices_HomeTech_Image_Mobile").ImageURL : this.resourceService.getPortalImage("Global_SPOE_Dashboard_Devices_HomeTech_Image_Desktop").ImageURL;
        }
    }

  async ngOnInit() {
    const joined$ = combineLatest([
      this.loggedInUserSettings.$selectedContract,
      this.loggedInUserSettings.$userClaims,
      this.loggedInUserSettings.$hasActiveAccount,
      this.loggedInUserSettings.$contracts,
      this.loggedInUserSettings.$eprismContracts,
    ]).pipe(
      filter(([a, b, c, d, e]) => a !== null && b !== null && c !== null),
      takeUntil(this.destroy$)
    );

    this.isSPOEEnabled = this.resourceService.isPortalSettingTrue("Global_SPOE_Enabled");

    if (this.isSPOEEnabled) {

      //this.claimsBackgroundImageURL = this.isMobileSize? this.resourceService.getPortalImage("Global_SPOE_Dashboard_Claims_Image_Mobile").ImageURL : this.resourceService.getPortalImage("Global_SPOE_Dashboard_Claims_Image_Desktop").ImageURL;
      //this.devicesBackgroundImageURL = this.isMobileSize? this.resourceService.getPortalImage("Global_SPOE_Dashboard_Devices_Image_Mobile").ImageURL : this.resourceService.getPortalImage("Global_SPOE_Dashboard_Devices_Image_Desktop").ImageURL;
      this.chatSupportBackgroundImageURL = this.isMobileSize? this.resourceService.getPortalImage("Global_SPOE_Dashboard_Chat_Image_Mobile").ImageURL : this.resourceService.getPortalImage("Global_SPOE_Dashboard_Chat_Image_Desktop").ImageURL;
      this.techServicesSupportBackgroundImageURL = this.isMobileSize? this.resourceService.getPortalImage("Global_SPOE_Dashboard_TechServices_Image_Mobile").ImageURL : this.resourceService.getPortalImage("Global_SPOE_Dashboard_TechServices_Image_Desktop").ImageURL;
    }

    this.smartDeviceImage = this.resourceService.getPortalImage('Global_Dashboard_Devices_Image');

    const settings: ISitefinityContentSettings = this.sitefinityContentService.getSettings();
    this.isPhonePlanSupported = this.resourceService.isPortalSettingTrue('Global_CTC_IsPhonePlanSupported');
    this.programCode = this.resourceService.getPortalSetting('Global_ProgramCode').Value;
    this.deviceRoute = this.resourceService.getPortalSetting('URL_MyDevices').Value;

    this.promoDashboardSlot = {
      heading: 'Dashboard_Promo_Heading',
      promoText: 'Dashboard_Promo_Text',
      secondaryHeader: 'Dashboard_Promo_Secondary_Header',
      secondaryText: 'Dashboard_Promo_Secondary_Text',
      imageKey: 'Global_Dashboard_Promo_TechSupport_ImageKey',
      callToActionLabel: 'Dashboard_Promo_CallToAction_Button_Label',
      isPromoAppType: this.resourceService.isPortalSettingTrue('Dashboard_Promo_IsPromoAppType'),
    };

    this.promoDashboardAppTypeSlot = {
      heading: 'Dashboard_Promo_AppType_Heading',
      promoText: 'Dashboard_Promo_AppType_Text',
      secondaryText: 'Dashboard_Promo_AppType_Secondary_Text',
      imageKey: 'Global_Promo_AppType_App_Image',
      googlePlayImageKey: 'Global_Promo_AppType_Apple_Image',
      appleStoreImageKey: 'Global_Promo_AppType_Google_Image',
      qrCodeImageKey: 'Global_Promo_AppType_QRCode_Image',
    };

    this.showDisclaimer = this.getSetting('Show_Disclaimer') === 'true' ? true : false;

    joined$.subscribe(([selectedContract, userClaims, hasActiveAccount, elitaContract, eprismContracts]: [ISelectedContract, UserClaims, boolean, IContract[], any[]]) => {
      const isLogin = localStorage.getItem('gtm_login_success');
      if (isLogin == 'true') {
        this.googleAnalyticsService.emitLoginEvent(GTMLoginEvents.LoginSuccess);
        localStorage.removeItem('gtm_login_success');
      }

      this.hasP360MobilePolicy = this.storageService.getLocal<string>(`EprismContractsCount`) > '0';
      this.hasP360HomeTechPolicy = this.storageService.getLocal<string>(`ElitaContractsCount`) > '0';
      this.hasMultiPolicies = this.hasP360HomeTechPolicy && this.hasP360MobilePolicy;
      this.isCancelled = selectedContract.isCancelled;
      this.isSuspended = selectedContract.isSuspended;
      this.isExpired = selectedContract.isExpired;
      this.isPTPO = selectedContract.isPTPO;
      this.isPrimary = selectedContract.isPrimary;
      this.cancelledOrExpiredHasFullAccess = this.resourceService.isPortalSettingTrue('Global_CancelledOrExpiredContract_HasFullAccess');
      this.disableCntrl = (this.isCancelled || this.isExpired) && !this.cancelledOrExpiredHasFullAccess;
      this.userEmail = userClaims.email;


      if (this.isSPOEEnabled) {
        this.coverageMobilePlanList = this.resourceService.getPortalSetting('Dashboard_Coverage_MobilePlan_List').Value.split(';');
        this.coverageHomePlanList = this.resourceService.getPortalSetting('Dashboard_Coverage_HomePlan_List').Value.split(';');
        this.getSPOEFAQListItems();

        if((this.hasP360MobilePolicy && !this.hasP360HomeTechPolicy) || (this.hasP360MobilePolicy && this.hasP360HomeTechPolicy)){
          this.claimsBackgroundImageURL = this.isMobileSize? this.resourceService.getPortalImage("Global_SPOE_Dashboard_Claims_Image_Mobile").ImageURL : this.resourceService.getPortalImage("Global_SPOE_Dashboard_Claims_Image_Desktop").ImageURL;
          this.devicesBackgroundImageURL = this.isMobileSize? this.resourceService.getPortalImage("Global_SPOE_Dashboard_Devices_Image_Mobile").ImageURL : this.resourceService.getPortalImage("Global_SPOE_Dashboard_Devices_Image_Desktop").ImageURL;
        }
        else{
          this.claimsBackgroundImageURL = this.isMobileSize? this.resourceService.getPortalImage("Global_SPOE_Dashboard_Claims_HomeTech_Image_Mobile").ImageURL : this.resourceService.getPortalImage("Global_SPOE_Dashboard_Claims_HomeTech_Image_Desktop").ImageURL;
          this.devicesBackgroundImageURL = this.isMobileSize? this.resourceService.getPortalImage("Global_SPOE_Dashboard_Devices_HomeTech_Image_Mobile").ImageURL : this.resourceService.getPortalImage("Global_SPOE_Dashboard_Devices_HomeTech_Image_Desktop").ImageURL;
        }
      }
      this.handleCancelExpiredBanners(selectedContract,eprismContracts);

      this.accountManagementUrl = this.getSetting('URL_Account_Management');
      this.accountManagementLabel = this.getLabel('Account_Management_Label');
      this.techServicesofferList = this.getSetting('TechServices_Offered')?.split(';');

      if (this.isPrimary) {
        this.benefitsOfferedList = this.getSetting('Benefits_Offered_Primary')?.split(';');
      } else if (!this.isPrimary) {
        this.benefitsOfferedList = this.getSetting('Benefits_Offered_Secondary')?.split(';');
      }
      this.isSupportOffered = this.getSetting('Support_Offered')?.toLowerCase() === 'true';
      if (this.isPrimary) {
        this.supportCenterOfferedServicesList = this.getSetting('Support_Offered_Primary')?.split(';');
        this.supportCenterComponentRoute = this.getSetting('URL_SupportCenter_Primary');
      } else if (!this.isPrimary) {
        this.supportCenterOfferedServicesList = this.getSetting('Support_Offered_Secondary')?.split(';');
        this.supportCenterComponentRoute = this.getSetting('URL_SupportCenter_Secondary');
      }

      if (settings?.DashboardPage?.upgradeBanner?.[0]) {
        // NOTE: we decided not to finish refactoring the UpgradeCallout component because the UpgradeCallout is only shown when the dealer code is PTPQA which only occurs for the PGH Organic portal which is an old portal. So no new portals will see this component so we don't have to worry about forgetting to set the properties up in the old Sitefinity, thus we don't have to refactor this.
        this.upgradeBanner = settings?.DashboardPage?.upgradeBanner?.[0];
      }

      if (selectedContract) {
        let devicesFromAllElitaInventories: DeviceDto[];
        this.accountService.getAllInventoriesWithDevicesForSelectedContract(this.destroy$).subscribe({
          next: (inventories) => {
            devicesFromAllElitaInventories = [
              ...(inventories?.cellularEnabledPolicyInventory?.devices ?? []),
              ...(inventories?.gadgetPolicyInventory?.devices ?? []),
              ...(inventories?.gadgetClientSoldPolicyInventory?.devices ?? []),
              ...(this.deviceInventoryService.getEprismDevices())
            ];
            this.selectedDeviceService.setAllDevices(
              (devicesFromAllElitaInventories ?? []).map((x) => this.deviceInventoryService.buildPghUserDeviceBaseFromDeviceDto(x))
            );
            if (this.isPhonePlanSupported && selectedContract.certificateNumberForPhonesPolicy) {
              this.phoneDevices = inventories?.cellularEnabledPolicyInventory?.devices ?? [];
              this.phonedeviceInventoryInfo = inventories?.cellularEnabledPolicyInventory?.info;
              let isPhoneDeviceInventoryEmpty: boolean = false;
              let allDevices: PghUserDeviceBase[] = this.selectedDeviceService.getAllDevices();

              if (this.phoneDevices.length === 0 && allDevices?.length === 0) {
                isPhoneDeviceInventoryEmpty = true;
                // Create New Phone Record
                if (selectedContract.members[0].phoneNumber) {
                  this.deviceInventoryService
                    .addPhoneNumberToInventory(selectedContract.members[0].phoneNumber, this.phonedeviceInventoryInfo?.id, true)
                    .subscribe((res) => {
                      this.selectedDeviceService.updateAllDevices(res);
                      // Phone Added
                    });
                }
              } else {
                let phonesFailedCount = 0;
                let phonesPendingCount = 0;
                let phonesPassedCount = 0;

                this.phoneDevices.forEach((device) => {
                  if (
                    device.diagnosticStatus === null ||
                    device.diagnosticStatus?.toUpperCase() === DeviceCardDiagnosticTestStatus.PASSED
                  ) {
                    phonesPassedCount++;
                  } else if (device.diagnosticStatus?.toUpperCase() === DeviceCardDiagnosticTestStatus.PENDING) {
                    phonesPendingCount++;
                  } else if (device.diagnosticStatus?.toUpperCase() === DeviceCardDiagnosticTestStatus.FAILED) {
                    phonesFailedCount++;
                  }
                });

                if (this.isPrimary) {
                  if (phonesPassedCount === 0 && phonesFailedCount === 0 && phonesPendingCount > 0) {
                    this.isPhonesStatusFailed = false;
                    this.isPhonesStatusPending = true;
                  } else if (phonesPassedCount === 0 && phonesPendingCount === 0 && phonesFailedCount > 0) {
                    this.isPhonesStatusFailed = true;
                    this.isPhonesStatusPending = false;
                  } else if (phonesPassedCount === 0 && phonesPendingCount > 0 && phonesFailedCount > 0) {
                    this.isPhonesStatusFailed = true;
                    this.isPhonesStatusPending = true;
                  } else {
                    this.isPhonesStatusFailed = false;
                    this.isPhonesStatusPending = false;
                  }
                }
                // alert('passed= ' + phonesPassedCount + ' pending= ' + phonesPendingCount + ' failed= ' + phonesFailedCount)
              }

              // TEMP
              if (this.isNewUserFlow === 'true') {
                isPhoneDeviceInventoryEmpty = true;
                this.isDashboardVisible = false;
                // Create New Phone Record
                if (selectedContract.members[0].phoneNumber) {
                  this.deviceInventoryService
                    .addPhoneNumberToInventory(selectedContract.members[0].phoneNumber, this.phonedeviceInventoryInfo?.id, true)
                    .subscribe((res) => {
                      this.selectedDeviceService.updateAllDevices(res);
                      // Phone Added+
                    });
                }
              } else {
                this.isDashboardVisible = true;
              }

              const redirectFrom = sessionStorage.getItem('redirect-from');
              const phoneOnboardingWelcome = sessionStorage.getItem('phone-onboarding-welcome');

              // TODO
              //const PHONE_ONBOARDING_SKIPPED_TEST_LOCAL_STORAGE_KEY = 'Pgh.PhoneOnboarding.SkippedTest';

              if (this.isPhonePlanSupported && this.isPrimary && isPhoneDeviceInventoryEmpty) {
                // TODO: create new phone record

                this.router.navigate(['/po']);
                this.isDashboardVisible = false;
              } else if (redirectFrom && redirectFrom === 'po') {
                sessionStorage.removeItem('redirect-from');
                this.firstTimeUserPhoneOnboardingModal(userClaims.sub);
                this.isDashboardVisible = true;
              }


              //selectedContract.members[0].phoneNumber


            } else {
              this.isDashboardVisible = true;
            }
            this.isMobilePlan = selectedContract.isMobilePlanActive && !!selectedContract.certificateNumberForGadgetsPolicy;

            this.setDashboardCards(selectedContract);
          },
          error: (error) => {
            throw error;
          },
        });



        this.selectedPlan = selectedContract.title;
        if (selectedContract.addressLine1) {
          this.address1 = this.util.getPascalCase(selectedContract.addressLine1);
        }
        this.address = `${this.util.getPascalCase(selectedContract?.city)}, ${selectedContract?.state} ${selectedContract?.zipCode}`;
      }

      if (!this.isPhonePlanSupported) {
        this.firstTimeUserModal(userClaims.sub);
      }

      this.isTechServicesEnabled = this.loggedInUserSettings.isFeatureEnabled(selectedContract.dealerId, TECHSERVICES);
      if (
        !this.loggedInUserSettings.isFeatureEnabled(selectedContract.dealerId, CHATGROUP) &&
        !this.loggedInUserSettings.isFeatureEnabled(selectedContract.dealerId, TECHGROUP)
      ) {
        this.isTechServicesEnabled = false;
      }
      this.isTechServicesChatEnabled =
        this.loggedInUserSettings.isFeatureEnabled(selectedContract.dealerId, CHATGROUP) &&
        this.loggedInUserSettings.isFeatureEnabled(selectedContract.dealerId, CHAT);
      this.hasActiveAccount = hasActiveAccount;
    });
  }

  showSuspendedModal() {
    const hasBeenShown = sessionStorage.getItem('suspended-banner-shown');
    if (hasBeenShown && hasBeenShown === 'true') {
      return;
    }
    const dialogData: ConfirmationDialogData = {
      title: 'Dashboard_Suspended_Modal_Title',
      message: 'Dashboard_Suspended_Modal_Message',
      cancelButtonText: 'Global_GoButton_Back',
      confirmButtonText: 'Global_OptOut',
      contextData: { titleLeftAligned: false, hideButtons: true },
    };

    this.matDialog.open<ConfirmationDialogComponent, ConfirmationDialogData>(ConfirmationDialogComponent, {
      data: dialogData,
    });
    sessionStorage.setItem('suspended-banner-shown', 'true');
  }

  getLabel(name: string, namespace = null): string {
    namespace = namespace ? namespace : 'Dashboard';
    const title = namespace + '_' + name;
    return this.resourceService.getLabel(title);
  }

  getSetting(name: string): string {
    return this.resourceService.getPortalSetting(name)?.Value;
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  get isControllerDisabled(): boolean {
    if (this.cancelledOrExpiredHasFullAccess) {
      return false;
    }
    return !((!this.isExpired && !this.isCancelled) || this.hasActiveAccount);
  }

  firstTimeUserPhoneOnboardingModal(userClaimsSub: string) {
    const isFirstTime = this.getCookie(userClaimsSub);
    if (!isFirstTime) {
      this.saveFirstTimeCookie(userClaimsSub);
      const dialogConfig = new MatDialogConfig();

      dialogConfig.disableClose = false;
      dialogConfig.ariaLabel = 'Get Started Dialog';
      dialogConfig.id = 'get-started-dialog';
      dialogConfig.height = 'auto';
      dialogConfig.data = {
        title: 'Account',
        content: '',
        buttonText: 'Next',
      };

      if (this.isNative) {
        return;
      }

      this.matDialog.open(GetStartedModalComponent, dialogConfig);
    }
  }

  firstTimeUserModal(userClaimsSub: string) {
    const isFirstTime = this.getCookie(userClaimsSub);
    if (!isFirstTime) {
      this.saveFirstTimeCookie(userClaimsSub);
      const dialogConfig = new MatDialogConfig();

      dialogConfig.disableClose = false;
      dialogConfig.ariaLabel = 'Get Started Dialog';
      dialogConfig.id = 'get-started-dialog';
      dialogConfig.height = 'auto';
      dialogConfig.data = {
        title: 'Account',
        content: '',
        buttonText: 'Next',
      };

      if (this.isNative) {
        return;
      }

      const isGetStartedModalEnabled: boolean = this.resourceService.isPortalSettingTrue('Global_GetStartedModal_Enabled');
      if (isGetStartedModalEnabled) {
        if (this.isMobilePlan) {
          // this.matDialog.open(GetStartedMobileModalComponent, dialogConfig);
          // TODO need to revisit
          this.matDialog.open(GetStartedModalComponent, dialogConfig);
        } else {
          this.matDialog.open(GetStartedModalComponent, dialogConfig);
        }
      }
    }
  }

  setDashboardCards(contract: ISelectedContract): void {
    if (this.isMobilePlan) {
      this.mobileDeviceService.getMobileDevicesSummary(contract.id).subscribe((mobileDeviceSummary) => {
        this.mobileDeviceSummary = mobileDeviceSummary;
      });
    }
    this.smartDevicesCount = this.selectedDeviceService.getAllDevices().length;
    //update the user's inventory device count in the UserInfo db
    const updateUserInfoDevicesCountDto: UpdateUserInfoDevicesCountDto = {
      EmailAddress: this.userEmail,
      DeviceCount: this.smartDevicesCount,
    };
    this.userInfoReportingService.updateUserInfoDevicesCount(updateUserInfoDevicesCountDto).subscribe({
      error: (err) => {
        throw err;
      },
    });
  }

  saveFirstTimeCookie(userClaimSub: string) {
    this.setCookie(userClaimSub, 'true', 365);
  }

  supportCenterButtonClick() {
    if (this.smartDevicesCount > 0) {
      this.router.navigate([this.supportCenterComponentRoute]);
    }
    //display a modal notification to user that they have no devices in their inventory with an option to navigate to My Devices page
    else {
      this.displayClaimsNoDevicesModal();
    }
  }

  displayClaimsNoDevicesModal(msg: string = '') {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.ariaLabel = this.resourceService.getPortalLabel('Global_Modal_NoDevices_Title').Value;
    dialogConfig.disableClose = false;
    dialogConfig.id = 'claims-no-devices-dialog';
    dialogConfig.height = 'auto';
    dialogConfig.data = {
      subtitle: 'Global_Modal_NoDevices_Subtitle',
      title: 'Global_Modal_NoDevices_Title',
      description: 'Global_Modal_NoDevices_Description',
      buttonText: 'Global_Modal_NoDevices_ButtonText',
    };

    const dialogRef = this.matDialog.open(ClaimsNoDevicesModalWindowComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((res) => {
      if (res.data && res.data.result === 'success') {
        this.router.navigate([this.resourceService.getPortalSetting('URL_MyDevices').Value]);
      }
    });
  }

  setCookie(name, value, days) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }
  getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let c of ca) {
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  eraseCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  goToMyDevices() {
    this.router.navigate([this.resourceService.getPortalSetting('URL_MyDevices').Value]);
  }

  goToClaims(){
    this.router.navigate(["/device-select"]);
  }

  goToChat(){
    const rnWindow = window as any;
    if (rnWindow.ReactNativeWebView) {
      const message = JSON.stringify({ action: 'openChat', args: {} });
      rnWindow.ReactNativeWebView.postMessage(message);
    }

    // Show chat
    const chatHandler = new ChatHandler(this.matDialog, this.resourceService, this.util, this.route, this.asappChatService);
    chatHandler.openChatInterface(this.hasP360MobilePolicy, this.hasP360HomeTechPolicy);
  }

  goToAccountManagement() {
    this.router.navigate([this.accountManagementUrl]);
  }

  goToTechServices() {
    this.router.navigate([this.techServicesRoute]);
  }

  handleTechServicesKeyDown(event: any) {
    if (event.keyCode === 13) {
      this.router.navigate([this.techServicesRoute]);
    }
  }

  handleAccountKeyDown(event: any) {
    if (event.keyCode === 13) {
      this.router.navigate([this.accountManagementUrl]);
    }
  }

  handleSupportCenterKeyDown(event: any) {
    if (event.keyCode === 13) {
      this.supportCenterButtonClick();
    }
  }

  handleMyDevicesKeyDown(event: any) {
    if (event.keyCode === 13) {
      this.router.navigate([this.resourceService.getPortalSetting('URL_MyDevices').Value]);
    }
  }

  redirectToGsspDashboard() {
    combineLatest([this.loggedInUserSettings.$selectedContract])
      .pipe(filter(([x]) => x != null))
      .subscribe(([contract]) => {
        if (
          contract.isPrimary &&
          ((!contract.isCancelled && !contract.isExpired) || this.cancelledOrExpiredHasFullAccess) &&
          contract.useGSSPClaims
        ) {
          const searchClaimsUrl = this.resourceService.getPortalSetting('URL_ClaimsPortal').Value;
          const masterCertificateNumber = contract.id;
          const dealerCode = contract.dealerId;
          if (masterCertificateNumber && masterCertificateNumber.length > 0) {
            const childCertificateNumbers: [string] = [masterCertificateNumber];
            this.gsspAuthService.postGenerateGSSPToken(dealerCode, masterCertificateNumber, childCertificateNumbers, null).subscribe({
              next: (gsspAuthToken: any) => {
                if (gsspAuthToken && gsspAuthToken.length > 0) {
                  let redirectUrl = `${searchClaimsUrl}?accessToken=${gsspAuthToken}`;
                  redirectUrl = this.sanitizer.sanitize(SecurityContext.URL, redirectUrl);
                  window.open(redirectUrl, '_self');
                }
              },
            });
          }
        }
      });
  }

  getViewLabel(item: string) {
    const label = this.resourceService.getViewLabel(item) ?? '';
    return this.resourceService.transformContentData(label);
  }

  getSPOEFAQListItems() {
    let questionIndex: number = 0;
    let answerIndex: number = 0;
    let faqMobileList: string[] = [];
    let faqHomeList: string[] = [];
    const manualMobileListArray = new Array();
    const manualHomeListArray = new Array();

    if (this.hasMultiPolicies) {
      faqHomeList = this.resourceService.getPortalSetting('Dashboard_FAQ_Product_HomeTech').Value.split(';');
      faqMobileList = this.resourceService.getPortalSetting('Dashboard_FAQ_Product_Eprism').Value.split(';');
    } else if (this.hasP360HomeTechPolicy) {
      faqHomeList = this.resourceService.getPortalSetting('Dashboard_FAQ_Product_HomeTech').Value.split(';');
    } else if (this.hasP360MobilePolicy) {
      faqMobileList = this.resourceService.getPortalSetting('Dashboard_FAQ_Product_Eprism').Value.split(';');
    }

    if (faqHomeList) {
      faqHomeList.forEach((faqItem) => {
        if (faqItem) {
          if (faqItem.includes('Question')) {
            manualHomeListArray.push([]);
            manualHomeListArray[questionIndex].questionKey = faqItem;
          } else if (faqItem.includes('Answer')) {
            manualHomeListArray[questionIndex].answerKey = faqItem;
            questionIndex++;
          }
          answerIndex++;
        }
      });

      this.homePlanFAQListItems = manualHomeListArray;
    }

    // reset
    questionIndex = 0;
    answerIndex = 0;

    if (faqMobileList) {
      faqMobileList.forEach((faqItem) => {
        if (faqItem) {
          if (faqItem.includes('Question')) {
            manualMobileListArray.push([]);
            manualMobileListArray[questionIndex].questionKey = faqItem;
          } else if (faqItem.includes('Answer')) {
            manualMobileListArray[questionIndex].answerKey = faqItem;
            questionIndex++;
          }
          answerIndex++;
        }
      });

      this.mobilePlanFAQListItems = manualMobileListArray;

    }
  }

  handleCancelExpiredBanners(selectedContract: ISelectedContract, eprismContracts: any[]) {
    if (this.hasMultiPolicies) {
      let oktaUserProfile = this.storageService.getLocal<OktaUserProfile>('okta-user-profile');
      if (oktaUserProfile && eprismContracts) {
        const eContract = eprismContracts.find(x => x.policyIdentifier.mobileNumber == oktaUserProfile.primaryPhone);
        //if hasMultiPolicies is true, then selectedContract will be the Elita contract, so need to separately check for canceled on the eprism contract
        if (this.checkEprismContractCancelled(eContract)) {
          let eprismNoticeBanner = getNoticeText('Dashboard_ContractCancelled', this.resourceService);
          const contractExpiredAccessPeriod = Number(this.resourceService.getPortalSetting('Dashboard_ContractExpired_Eprism_Access_Period').Value);
          eprismNoticeBanner.noticeText = this.processNoticeBannerText(eprismNoticeBanner.noticeText, this.resourceService.getPortaLabelValue('Global_Eprism_Product_Name'), eContract.coverageInfo.endDate, contractExpiredAccessPeriod)
          this.noticeBanners.push(eprismNoticeBanner);
          this.bannersVisibility.push(true);
        }
      }
    }
    if (this.isCancelled) {
      const programName = selectedContract.isEprismContract ? this.resourceService.getPortaLabelValue('Global_Eprism_Product_Name') : this.resourceService.getPortaLabelValue('Global_Product_Name');
      const contractExpiredAccessPeriod = selectedContract.isEprismContract ?
        Number(this.resourceService.getPortalSetting('Dashboard_ContractExpired_Eprism_Access_Period').Value) :
        Number(this.resourceService.getPortalSetting('Dashboard_ContractExpired_Access_Period').Value);
      let noticeBanner = getNoticeText('Dashboard_ContractCancelled', this.resourceService);
      noticeBanner.noticeText = this.processNoticeBannerText(noticeBanner.noticeText, programName, selectedContract.cancellationDate, contractExpiredAccessPeriod)
      this.noticeBanners.push(noticeBanner);
      this.bannersVisibility.push(true);
    }
    if (this.isExpired) {
      this.noticeBanners.push(getNoticeText('Dashboard_ContractExpired', this.resourceService));
      // Do not show the Notice banner if contract is expired and still has full access.
      if (this.cancelledOrExpiredHasFullAccess && this.isExpired) {
        this.bannersVisibility.push(false);
      }
    }
  }

  checkEprismContractCancelled(eContract: any): boolean {
    let today = new Date();
    //contracts that are active will have endDate set to 9999-12-31 per Eprism
    if (eContract && !new Date(eContract.coverageInfo.endDate).toISOString().startsWith("9999-12-31")) {
      return Date.parse(eContract.coverageInfo.endDate) < Date.parse(today.toLocaleDateString());
    }
  }

  processNoticeBannerText(noticeText: string, programName: string, cancellationDate: Date, afterCancelOpenPeriod: number): string {
    if (noticeText.includes('{endDate')) {
        var cancelDate = new Date(cancellationDate);
        cancelDate.setDate(cancelDate.getDate() + afterCancelOpenPeriod);
        const endDateStr = format(cancelDate, 'MM/dd/yyyy');
        let temp = noticeText;
        temp = temp.replace('{endDate}', endDateStr);
        noticeText = temp;
      }
      if(noticeText.includes('{programName')) {
        let temp = noticeText;
        temp = temp.replace('{programName}', programName);
        noticeText = temp;
      }
    return noticeText;
  }
}
